export enum SnitcherEventNames {
  WEB_INSTALL = 'web_install',
  FUNNEL_SCREEN_OPEN = 'funnel_screen_open',
  FUNNEL_SCREEN_CLICK = 'funnel_screen_click',
  FUNNEL_SCREEN_SCROLL = 'funnel_screen_scroll',
  FUNNEL_MODAL_OPEN = 'funnel_modal_open',
  FUNNEL_MODAL_CLICK = 'funnel_modal_click',
  PAYMENT_FORM_STATE = 'payment_form_state',
  PAYMENT_FORM_COMPLETED = 'payment_form_completed',
  ARRIVAL = 'arrival',
  FUNNEL_INFO = 'funnel_info',
}

const funnelProperties = ['project_id', 'funnel_id', 'flow_id'];
const screenProperties = ['screen_id', ...funnelProperties];
const stepProperties = ['funnel_step_number', ...screenProperties];
const modalProperties = ['screen_context', 'value', ...stepProperties];

export const snitcherContractProperties: Record<SnitcherEventNames, string[]> = {
  [SnitcherEventNames.WEB_INSTALL]: ['email', 'funnel'],
  [SnitcherEventNames.FUNNEL_SCREEN_OPEN]: stepProperties,
  [SnitcherEventNames.FUNNEL_SCREEN_CLICK]: [...stepProperties, 'value', 'email'],
  [SnitcherEventNames.FUNNEL_SCREEN_SCROLL]: [...screenProperties, 'coverage', 'scroll_details'],
  [SnitcherEventNames.FUNNEL_MODAL_OPEN]: modalProperties,
  [SnitcherEventNames.FUNNEL_MODAL_CLICK]: modalProperties,
  [SnitcherEventNames.PAYMENT_FORM_STATE]: ['state', 'payment_method', ...funnelProperties],
  [SnitcherEventNames.PAYMENT_FORM_COMPLETED]: [
    'state',
    'payment_method',
    'card_brand',
    'card_type',
    'order_id',
    'product_id',
    'reason',
    ...funnelProperties,
  ],
  [SnitcherEventNames.ARRIVAL]: ['host', 'path', 'referrer', 'user_id', 'is_tester'],
  [SnitcherEventNames.FUNNEL_INFO]: ['platform', 'country', 'language', ...funnelProperties],
};

const snitcherEventNames = new Set<string>(Object.values(SnitcherEventNames));

export const isSnitcherEventName = (eventName: string): eventName is SnitcherEventNames =>
  snitcherEventNames.has(eventName);
